import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { SlPill } from 'src/components/BeaconV2Components/SlPill';
import color from 'src/utils/colors';
import { useCreditStatus } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/hooks/useContentGenerate';
import SlSkeleton from 'src/components/BeaconV2Components/SlSkeleton/SlSkeleton';

const CreditBalanceSection = () => {
  const { creditBalance, isLoading: isLoadingCredits, isError: creditError } = useCreditStatus();

  return (
    <Flex flexDirection="column">
      <Text variant="h4">Credit Balance</Text>
      <Flex marginTop="8px">
        This credit balance is used for generating new product content. Contact Stackline customer support to increase
        your credit balance.
      </Flex>
      <Flex marginTop="16px" flexDirection="row" gap={16} alignContent="center">
        {isLoadingCredits ? (
          <SlSkeleton variant="rectangular" width={150} height={32} sx={{ borderRadius: '16px' }} />
        ) : (
          <SlPill
            sx={{
              backgroundColor: color.graysPrimary,
              border: `1px solid ${color.graysSecondary}`,
              borderRadius: '16px',
              fontSize: '14px',
              fontWeight: 500,
              fontStyle: 'normal',
              display: 'flex',
              height: '32px',
              padding: '6px 20px',
              alignItems: 'center',
              color: creditError ? color.red : 'inherit',
              cursor: 'default'
            }}
          >
            {creditError ? 'Error loading credits' : `${creditBalance} credits available`}
          </SlPill>
        )}
        <Text sx={{ alignContent: 'center' }} variant="body2">
          <span style={{ fontWeight: 500, fontSize: '14px', fontStyle: 'normal' }}>Note:</span> One credit is used to
          generate new content for a product.
        </Text>
      </Flex>
    </Flex>
  );
};

export default CreditBalanceSection;
